import * as React from "react";
import { useFormik } from "formik";
import { Link, useParams } from "react-router-dom";
import { useMutation } from "@apollo/client";
import gql from "graphql-tag";
import { toast } from "react-toastify";

// Components
import InputText from "../InputText/InputText";
import Loader from "../Loader/Loader";
import ChangeLanguage from "../ChangeLanguage/ChangeLanguage";

// Utils
import { SEND_PASSWORD_RESET_MAIL } from "../../queries/User.queries";
import useLanguageString from "../../hooks/LanguageStrings.hooks";

// Styles
import LoginIllustration from "../../static/images/login-illustration.svg";
import SonnenLogo from "../../static/images/logo-sonnen-white.svg";
import "./RequestPasswordReset.scss";

const MUTATION_SEND_RESET_MAIL = gql`
  ${SEND_PASSWORD_RESET_MAIL}
`;

const RequestPasswordReset: React.FC = () => {
  const params: any = useParams();
  const [sendResetPasswordMail] = useMutation(MUTATION_SEND_RESET_MAIL);
  const [strings] = useLanguageString(params.countryCode, "password");

  const formik = useFormik({
    initialValues: {
      username: "",
    },
    onSubmit: (values) => {
      const { username } = values;

      if (username) {
        sendResetPasswordMail({ variables: { username } })
          .then(() => {
            toast.success(strings?.password.stringSuccess);
          })
          .catch(() => {
            toast.error(strings?.password.stringError);
          });
      }
    },
  });

  return (
    <div className="resetPassword">
      <div className="resetPassword-container">
        <div className="resetPassword-container__inner">
          <div className="resetPassword-container__header">
            <img src={SonnenLogo} alt="sonnen" />
          </div>
          {!strings && <Loader />}
          {strings && (
            <>
              <div className="resetPassword-container__intro">
                <div className="resetPassword-container__intro__illustration">
                  <img src={LoginIllustration} alt="resetPassword" />
                </div>
                <h1>{strings.password.stringHeadline}</h1>
              </div>
              <form onSubmit={formik.handleSubmit}>
                <InputText
                  id="username"
                  label={strings.password.stringMail}
                  type="email"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  required
                />
                <button type="submit" className="mt-4">
                  {strings.password.stringButton}
                </button>
              </form>
              <p className="resetPassword-container__register text-muted">
                {strings.password.stringBack}{" "}
                <Link to={`/${params.countryCode}/login`}>
                  {strings.password.stringBackTitle}
                </Link>
              </p>
              <ChangeLanguage />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RequestPasswordReset;
